module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "vue-progress-indicator"
  }, [_c('a', {
    staticClass: "indicator-handle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleVisibility($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-align-left menu-glyphicon"
  }), _vm._v(" "), (_vm.hasProgress) ? _c('span', {
    staticClass: "badge progress-bar-info"
  }, [_vm._v(_vm._s(_vm.items.length))]) : _vm._e()]), _vm._v(" "), (_vm.hasProgress) ? _c('div', {
    staticClass: "dropdown-menu progress-list-container",
    style: ({
      display: _vm.listVisible ? 'block' : 'none'
    })
  }, [(this.errorMsg.length) ? _c('div', {
    staticClass: "errorMsg bg-danger well-sm"
  }, [_vm._v("\n            " + _vm._s(_vm.errorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.hasProgress) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((this.items), function(i) {
    return _c('progress-bar', {
      attrs: {
        "progress": i
      }
    })
  })) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad25c876"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/ProgressIndicator.vue
// module id = 1114
// module chunks = 0